define('suitecommerce_pageprinter.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('suitecommerce_pageprinter', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return " ";
},"useData":true}, 'extensions/SuiteCommerce/ProductPagePrinter/1.0.1/', 'extensions/SuiteCommerce/ProductPagePrinter/1.0.1/', Handlebars);
});